<mp-chip-item-selector
  [label]="label"
  [allOptions]="enumSelectorOptions"
  [selectedItems]="selectedValues"
  (selectedItemsChange)="onSelectedValuesChange($event)"
/>
